import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


function ImageSlider({ images }) {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000
  };
  return (
    <div className="slider-container pb-8">
      <Slider {...settings}>
        {images?.map((image) => (
          <figure className="relative h-56 sm:h-[420px] overflow-hidden rounded-2xl" key={image.id}>
            <img className="h-full w-full object-cover" src={image.source} alt={image.description} />
            <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-5 pt-16 text-left text-sm font-medium text-white">
              {image.description}
            </figcaption>
          </figure>
        ))}
      </Slider>
    </div>
  );
}
export default ImageSlider;